/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取分类匹配数
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  countCondition: good.CategoryMacthCountCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.CategoryMatchCountDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/search-category-count`,
    data: countCondition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
